module.exports = __webpack_public_path__ + "static/media/community-Francisca.1bd1956f.jpg";